<template>
    <div>
        <table v-if="orderDetail && orderDetail.list">
            <thead>
                <tr class="th">
                    <td>品牌</td>
                    <td>规格编号</td>
                    <td>CAS</td>
                    <td>包装单位</td>
                    <td>纯度</td>
                    <td>价格</td>
                    <td>购买数量</td>
                    <td>发货数量</td>
                    <td>发货状态</td>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in orderDetail.list" :key="index">
                    <td>{{item.brandName}}</td>
                    <td>
                        <div>{{item.specsNo}}</div>
                        <div v-if="item.busiStatus === 1" style="color: red; font-size: 12px;">已取消</div>
                    </td>
                    <td>{{item.casCode}}</td>
                    <td>{{item.packingUnit}}</td>
                    <td>{{item.purity}}</td>
                    <td>
                        <span style="color: red;">{{item.discountMoney}}</span>
                        <span
                            style="color: #999; text-decoration: line-through; font-size: 12px; margin-left: 5px;"
                        >{{item.originalAmount}}</span>
                    </td>
                    <td>{{item.amount}}</td>
                    <td>{{item.deliverAmount}}</td>
                    <td>{{deliverStatus[item.deliverStatus]}}</td>
                </tr>
            </tbody>
        </table>
        <div
            class="table-empty"
            v-if="!orderDetail || !orderDetail.list || (orderDetail.list && orderDetail.list.length === 0)"
        >
            <i class="el-icon-document-copy"></i>
            <p>暂无数据</p>
        </div>
        <div class="pagination">
            <el-pagination
                v-if="orderDetail"
                background
                layout="prev, pager, next,total"
                :total="orderDetail.count"
                :page-size="orderDetail.pageSize"
                :current-page="orderDetail.page"
                @current-change="handleCurrentChange"
            ></el-pagination>
        </div>
    </div>
</template>

<script>
import * as apis from '../../fetch/order';

export default {
    name: 'OrderItem',
    props: ['orderId'],
    data() {
        return {
            orderDetail: null,
            deliverStatus: {
                1: '未发货',
                2: '部分发货',
                3: '全部发货',
            },
        };
    },
    watch: {
        orderId(val) {
            this.getOrderDetail();
        },
    },
    methods: {
        getOrderDetail(page = 1) {
            apis.getOrderDetail({ orderId: this.orderId, page }).then(res => {
                this.orderDetail = res;
            });
        },
        handleCurrentChange(page) {
            this.getOrderDetail(page);
        },
    },
    mounted() {
        this.getOrderDetail();
    },
};
</script>


<style scoped lang="less">
</style>